import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsPOSTApi, AdsPUTApi } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import PicturesUpload from "./MediaArrayUpload";

export default function ImageUploadMain(props) {

  const history = useHistory()
  const [ID, setID] = React.useState("11796")


  const [reload, setReload] = React.useState(false)
  const [ImageArray, setImageArray] = React.useState([])
  const [GetAll, setGetAll] = React.useState(false)
  const [ImageArrayReload, setImageArrayReload] = React.useState(true)
  const [ImageArrayWeb, setImageArrayWeb] = React.useState([])
  const [ImageArrayWebReload, setImageArrayWebReload] = React.useState(true)


  const [ImageArray1, setImageArray1] = React.useState([])
  const [ImageArrayReload1, setImageArrayReload1] = React.useState(true)
  const [ImageArrayWeb1, setImageArrayWeb1] = React.useState([])
  const [ImageArrayWebReload1, setImageArrayWebReload1] = React.useState(true)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const [QuestionsBlock, setQuestionsBlock] = React.useState(true);
  const [QuestionsData, setQuestionsData] = React.useState(
    []
    // JSON.parse(FetchData.meta.marquee_element)
  );
  const [BatchExamDeleteIndex, setBatchExamIndex] = React.useState("")
  const [BatchExamDeleteModal, setBatchExamDeleteModal] = React.useState(false)

  const EditInfo = () => {
    setReload(true)
    const data = {
      "meta": {
        picture_url_list: JSON.stringify(ImageArray),
        web_picture_url_list: JSON.stringify(ImageArrayWeb),
        picture_url_list1: JSON.stringify(ImageArray1),
        web_picture_url_list1: JSON.stringify(ImageArrayWeb1),
        "marquee_element": JSON.stringify(QuestionsData)
      }
    }
    AdsPUTApi(data, "images", ID)
      .then((res) => {
        setReload(false)
        setAlertShow(true)
      }).catch(err => {
        console.log(err)
        console.warn(err.response.data)
        console.log("Response Status: hello11", err.response.status);
        console.log("Response Headers:", err.response.headers);
        setReload(false)
        setAlertShow(true)
        setAlertcomp(err.response.data.message)
      })
  }
  const onChangeFunction = (key, value, index) => {
    var changeValue = {
      ...Object.values(QuestionsData)[index],
      [key]: value
    }
    var AllChange = {
      ...QuestionsData,
      [Object.keys(QuestionsData)[index]]: changeValue
    }
    setQuestionsData(AllChange)

  }
  useEffect(() => {
    fetchSliders()
  }, [])
  const fetchSliders = () => {
    setImageArrayReload(false)
    AdsGETApi({ _fields: "meta" }, "images")
      .then((res) => {
        if (res.data.length !== 0)
          if (res.data[0].meta.picture_url_list.length !== 0) {
            setImageArray(JSON.parse(res.data[0].meta.picture_url_list))
            setImageArrayWeb(JSON.parse(res.data[0].meta.web_picture_url_list))
            setQuestionsData(JSON.parse(res.data[0].meta.marquee_element))
            setImageArray1(JSON.parse(res.data[0].meta.picture_url_list1))
            setImageArrayWeb1(JSON.parse(res.data[0].meta.web_picture_url_list1))
            setGetAll(true)
          }
        // setImageArrayReload(true)
        // setImageArrayReload1(true)
      })
  }
  const pdfURL = '1-5.pdf';

  return (
    <div>
      <div>
        <div className="row" style={{ padding: "30px 30px" }}>
          <div className="col-md-8 button">
            <h2>App Home Page Image </h2>
          </div>
          <div className="col-md-4" style={{ textAlign: 'right' }}>
            <a href="/">Dashboard</a> / <a href={slugs.all_books}>All Image</a>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2 col-1"></div>
          <div className="col-sm-8 col-10 form-view mb-3">
            <h4><center>Pictures Upload</center></h4>
            {GetAll &&
              <table>
                <tbody>
                  <tr>
                    Mobile First Banner
                    {/* {JSON.stringify(ImageArrayReload)} */}
                    <PicturesUpload
                      ImageArray={ImageArray}
                      setImageArray={setImageArray}
                      ImageArrayReload={ImageArrayReload}
                      setImageArrayReload={setImageArrayReload}
                    />
                  </tr>
                  <tr>
                    Mobile Second Banner
                    <PicturesUpload
                      ImageArray={ImageArray1}
                      setImageArray={setImageArray1}
                      ImageArrayReload={ImageArrayReload1}
                      setImageArrayReload={setImageArrayReload1}
                    />
                  </tr>
                  <tr>
                    Desktop First Banner
                    <PicturesUpload
                      ImageArray={ImageArrayWeb}
                      setImageArray={setImageArrayWeb}
                      ImageArrayReload={ImageArrayWebReload}
                      setImageArrayReload={setImageArrayWebReload}
                    />
                  </tr>
                  <tr>
                    Desktop Second Banner
                    <PicturesUpload
                      ImageArray={ImageArrayWeb1}
                      setImageArray={setImageArrayWeb1}
                      ImageArrayReload={ImageArrayWebReload1}
                      setImageArrayReload={setImageArrayWebReload1}
                    />
                  </tr>
                </tbody>
              </table>
            }

            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    EditInfo()
                  }}
                >
                  Update
                </div>
              </div>
            </div>
          </div>
        </div>

        {BatchExamDeleteModal &&
          <section className="modal" >
            <div className="row">
              <div className="col-md-3 col-1"></div>
              <div className="col-md-6 col-10  shadow bg-white">
                <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                  <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                    onClick={() => {
                      setBatchExamDeleteModal(false)
                    }}
                  >X</div>
                  Do you really want to delete This Note?
                  <table>
                    <tbody>
                      <tr>
                        <td>Title : </td>
                        <td>{QuestionsData[BatchExamDeleteIndex].title}</td>
                      </tr>
                      <tr>
                        <td>Link : </td>
                        <td>{QuestionsData[BatchExamDeleteIndex].link}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="row" >
                    <div className="col-1 center " />
                    <div className="col-5 center " >
                      <div className="sign-in-button-4" style={{ width: "80%" }}
                        onClick={() => {
                          setBatchExamDeleteModal(false)
                        }}
                      >
                        Cancel
                      </div>
                    </div>
                    <div className="col-5 center">
                      <div className="sign-in-button-4" style={{ width: "80%" }}
                        onClick={() => {
                          // BatchExam.splice(BatchExamDeleteIndex, 1)
                          // BatchExamID.splice(BatchExamDeleteIndex, 1)
                          delete QuestionsData[BatchExamDeleteIndex]
                          setBatchExamDeleteModal(false)
                        }}
                      >
                        OK
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }

        {reload &&
          <div className="modal" style={{ padding: "50vw" }}>
            <div className="dot-pulse"></div>
          </div>
        }
      </div>
    </div >
  )

}